import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  CertificateOfInspectionId,
  Exit,
  GateAway,
  GrantPeriod,
  GrantedArea,
  LicensePlate,
  NumberOfVehicleLicensesIssued,
  Team,
  VehicleName,
  VehicleRegistrationCertificateId,
} from "./_fields";

type BusinessVehicleCardLongTermProvideTemplate = {
  nameVehical: string;
  licensePlate: string;
  vehicleRegistrationCertificateId: number;
  certificateOfInspectionId: number;
  grantPeriod: string;
  grantedArea: string;
  gateAway: string;
  exit: string;
  unit: string;
  NumberOfVehicleLicensesIssued: string;
};

export const businessVehicleCardLongTermProvideTemplate: TemplatesValue<BusinessVehicleCardLongTermProvideTemplate> =
  {
    fileName: "DanhSachThongTinPhuongTienDaiHanCapMoi",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      VehicleName,
      LicensePlate,
      VehicleRegistrationCertificateId,
      CertificateOfInspectionId,
      GrantPeriod,
      GrantedArea,
      GateAway,
      Exit,
      Team,
      NumberOfVehicleLicensesIssued,
    ],
    fields: [
      "nameVehical",
      "licensePlate",
      "vehicleRegistrationCertificateId",
      "certificateOfInspectionId",
      "grantPeriod",
      "grantedArea",
      "gateAway",
      "exit",
      "unit",
      "NumberOfVehicleLicensesIssued",
    ],
  };
